import styled from 'styled-components';

import colors from './colors';

// TEXT

const BaseText = styled.span<{ color?: string }>`
  font-family: 'Quicksand', sans-serif;
  font-style: normal;
  color: ${props => props.color || colors.darkGray};
  word-break: break-word;
  line-height: 1.5;
`;

export const MiniText = styled(BaseText)`
  font-size: 10px;
  font-weight: bold;
`;

export const SmallText = styled(BaseText)`
  font-size: 11px;
  font-weight: bold;
`;

export const MediumText = styled(BaseText)`
  font-size: 12px;
  font-weight: bold;
`;

export const RegularText = styled(BaseText)`
  font-size: 13px;
  font-weight: 600;
`;

export const LargeText = styled(BaseText)`
  font-size: 16px;
  font-weight: bold;
`;

export const ExtraLargeText = styled(BaseText)`
  font-size: 21px;
  font-weight: bold;
`;

// INPUTS

export const BaseTextInput = styled.input`
  font-family: 'Quicksand', sans-serif;
  color: ${colors.darkGray};
  outline: none;
  padding: 10px 8px;
  box-sizing: border-box;
  transition: border-color 0.2s ease;
  font-style: normal;
  font-weight: normal;

  &::placeholder {
    color: ${colors.captures};
  }

  &::-webkit-input-placeholder {
    color: ${colors.captures};
  }
`;

export const RegularTextInput = styled(BaseTextInput)`
  font-size: 13px;
  line-height: 1.5;
  font-weight: 600;
`;

export const Title = styled(RegularText)`
  margin: 10px 0 20px 0;
  text-align: center;
  color: ${colors.darkGray};
`;

export const SectionTitle = styled(RegularText)`
  text-transform: uppercase;
  margin: 10px 0;
  color: ${colors.main2};
`;
